import React from 'react'
import ActionButtonMenu from './action-button-menu'
import type { ActionWrapperProps } from './types'

const ActionWrapper: React.FC<ActionWrapperProps> = ({
  children,
  hiddenActions = [],
  anchorEl,
  isMenuOpen,
  setIsMenuOpen,
  anchorOrigin,
  transformOrigin,
  topMenuMargin,
}) => (
  <>
    {children}
    {hiddenActions.length > 0 && (
      <ActionButtonMenu
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        actions={hiddenActions}
        open={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
        anchorEl={anchorEl}
        topMenuMargin={topMenuMargin}
      />
    )}
  </>
)

export default ActionWrapper
